import { render, staticRenderFns } from "./PcSocialSecurityNumberTextField.vue?vue&type=template&id=c1a01e54&scoped=true"
import script from "./PcSocialSecurityNumberTextField.vue?vue&type=script&lang=js"
export * from "./PcSocialSecurityNumberTextField.vue?vue&type=script&lang=js"
import style0 from "./PcSocialSecurityNumberTextField.vue?vue&type=style&index=0&id=c1a01e54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a01e54",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
